import React from 'react';
import LocationTemplate from './LocationTemplate';

const BathPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Bath"
      stateName="North Carolina"
      countyName="Beaufort"
      zipCodes={["27808"]}
      latitude={35.4735}
      longitude={-76.8080}
      population={249}
      historicalFact="North Carolina's oldest incorporated town (1705), once home to the infamous pirate Blackbeard."
      nearbyTowns={[
        "Washington, NC",
        "Chocowinity, NC",
        "Aurora, NC",
        "Belhaven, NC",
        "Edward, NC",
        "Pinetown, NC",
        "Pantego, NC",
        "Swan Quarter, NC"
      ]}
    />
  );
};

export default BathPage;